import {FC} from 'react';
//mui
import {Box, Typography} from '@mui/material';
import {Link} from 'react-router-dom';
//constants
import {BODY1} from '@/utils/constants';
//style
import {modalInfoDescriptionStyle} from './ModalInfoDescription.style';
import Button from '@/shared/components/Button';

const ModalInfoDescription: FC = () => {
  const emailTo = process.env.REACT_APP_EMAIL_TO;

  const handleContactUs = () => {
    const subject = encodeURIComponent('EventSimply support request');
    window.location.href = `mailto:${emailTo}?subject=${subject}`;
  };

  return (
    <Box>
      <Typography variant={BODY1}>
        We support connecting Stripe payment processing accounts to collect online payments and/or donations. It is safe
        and secure and simplify the payment process for both bidders and auction administrators. All financial
        information is protected when using this payment process. EventSimpli never collects confidential payment
        information and instead routes all payments through the payment processor(s) of your choice.
      </Typography>

      <br />
      <br />

      <Typography variant={BODY1} sx={modalInfoDescriptionStyle.listTitle}>
        For more information, please see:
      </Typography>

      <Box component="ul">
        <Box component="li" sx={modalInfoDescriptionStyle.listItem}>
          <Link to="/#">About transcations fees?</Link>
        </Box>
        {/* <Box component="li" sx={modalInfoDescriptionStyle.listItem}>
					<Link to="/#">How do I connect a PayPal payment account to my auction?</Link>
				</Box> */}
        <Box component="li" sx={modalInfoDescriptionStyle.listItem}>
          <Link to="/#">How do I connect a Stripe payment account to my auction?</Link>
        </Box>
        {/* <Box component="li" sx={modalInfoDescriptionStyle.listItem}>
					<Link to="/#">How do I connect a Square payment account to my auction?</Link>
				</Box> */}
      </Box>

      <br />
      <br />

      <Box sx={modalInfoDescriptionStyle.linkHelp}>
        <Typography variant={BODY1}>Need more help?</Typography>
        <Button onClick={handleContactUs} variant="text" title="Contact our Help Center" sx={{marginLeft: '5px'}}/>
      </Box>
    </Box>
  );
};

export default ModalInfoDescription;
